export default __webpack_public_path__ + "static/media/facebook-business-manager.9394c49b.svg";